// HEADER
let coHeaderFiller = gsap.getProperty(".header", "height");
gsap.to('.co--header--wave--bg', {duration: 0.1, height: coHeaderFiller + 1});
let coHeaderSpacer = gsap.getProperty(".co--header--wave", "height");
gsap.to('.co--header--wave--svg', {repeat: -1, duration: 10, xPercent: -100, ease: 'none'});
gsap.to('.co--header--spacer', { duration: 0, marginTop: -coHeaderSpacer });

let coMobileDrawerHeight = window.innerHeight - coHeaderFiller;
gsap.to('#menu-drawer', {duration: 0, height: coMobileDrawerHeight });

// HOME HERO
gsap.to('.co--home--hero', { duration: 0.5, opacity: 1 });
gsap.to('.co--home--hero--marquee--content', {repeat: -1, duration: 25, xPercent: -100, ease: 'none'});
// HOME EMBROIDERY PLAY
gsap.to('.co--home--embroidery--middle--right>svg', {repeat: -1, duration: 5, rotationY: 360, ease: 'none'});
Draggable.create(".co--home--embroidery--bottom img", {type:"x,y", edgeResistance: 0.65, bounds: ".co--home--embroidery", inertia: true});
// HOME MARQUEE
gsap.to('.co--home--marquee>div>div', {repeat: -1, duration: 15, xPercent: -100, ease: 'none'});
// OUR STORY
gsap.to('.co--our-story--hero', { duration: 0.5, opacity: 1 });
// FAQ
gsap.to('.co--faq--hero', { duration: 0.5, opacity: 1 });
// PDP
gsap.to('.co--product', { duration: 0, paddingTop: coHeaderSpacer});
// COLLECTION
gsap.to('.co--collection--marquee--content', {repeat: -1, duration: 15, xPercent: -100, ease: 'none'});


// ==================================================================================== SECTION 5
// MARQUEE
(function () {
let tickerSpeed = 1;
let flickity = null;
let isPaused = false;
const slideshowEl = document.querySelector('.co-home-section-1-carousel');
if (!slideshowEl) return;
const update = () => {
  if (isPaused) return;
  if (flickity.slides) {
    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
    flickity.selectedIndex = flickity.dragEndRestingSelect();
    flickity.updateSelectedSlide();
    flickity.settle(flickity.x);
  }
  window.requestAnimationFrame(update);
};
const pause = () => {
  isPaused = true;
};
const play = () => {
  if (isPaused) {
    isPaused = false;
    window.requestAnimationFrame(update);
  }
};
flickity = new Flickity(slideshowEl, {
  autoPlay: false,
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: true,
  selectedAttraction: 0.015,
  friction: 0.25
});
flickity.x = 0;
slideshowEl.addEventListener('mouseenter', pause, false);
slideshowEl.addEventListener('focusin', pause, false);
slideshowEl.addEventListener('mouseleave', play, false);
slideshowEl.addEventListener('focusout', play, false);
flickity.on('dragStart', () => {
  isPaused = true;
});
update();
})();
